import * as React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import {useNavigate} from "react-router-dom";
import nav from "./nav";

export default function NavMenu() {
    const [alignment, setAlignment] = React.useState(nav[0].name);
    let navigate = useNavigate();
    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: string,
    ) => {
        setAlignment(newAlignment);
    };
    return (
        <ToggleButtonGroup style={{marginTop: "8px"}}
                           color="primary"
                           value={alignment}
                           exclusive
                           onChange={handleChange}
        >

            {nav.map((item) => {
                return <ToggleButton key={item.name} value={item.name}
                                     onClick={() => {
                                         navigate(item.path, {})
                                     }}
                >{item.name}    </ToggleButton>
            })}

        </ToggleButtonGroup>
    );
}
